// #237 — rollout gate for the coops.pt ↔ org processing contract
// (/contrato-de-subcontratacao).
//
// The document is still a DRAFT: not legally reviewed, not signed, and with an
// open structural question (Minga is both the platform operator and an org on
// the platform, so for the Minga instance the contract would be with itself).
// It is therefore shown to Pro Nobis only for now.
//
// To widen the rollout, add the org's VITE_CLIENT here; to ship it everywhere,
// delete this module and its call sites. Org gating via VITE_CLIENT follows the
// existing precedent in App.vue (the pronobis import-status banner).
const ENABLED_CLIENTS = ['pronobis']

export const isDataProcessingAgreementEnabled = (client = import.meta.env.VITE_CLIENT) =>
  ENABLED_CLIENTS.includes(client)
